/* global Function */
var ofType = require('of-type');

var cliColor = require('cli-color');

var error = cliColor.red;
var warn = cliColor.blue.bgYellow;

module.exports = function (getArgumentsObject, getExpectedArray, callbackFunction) {
  var clb = ofType(callbackFunction, 'function');
  validateArguments(getArgumentsObject, getExpectedArray);

  for (var i = 0; i < getExpectedArray.length; i++) {
    if (!ofType(getArgumentsObject[i], getExpectedArray[i])) {
      var actual = getActualType(getArgumentsObject[i]);
      var types = getExpectedTypes(getExpectedArray[i]);
      var message = "Invalid argument [".concat(i, "]. The [").concat(actual, "] ").concat(types.truthness, "argument has been passed, while the ").concat(types.message, " is expected.");

      if (clb) {
        callbackFunction({
          actual: actual,
          expected: types.expected,
          message: message,
          index: Number(i)
        });
        return false;
      } else {
        var err = new TypeError(message);
        throw err;
      }
    }
  }

  return true;
};

function validateArguments(a, o) {
  var errActual = warn('typeof-arguments') + ': ' + error('Invalid module argument. The first argument must be [arguments] Object.');
  var errExpected = warn('typeof-arguments') + ': ' + error('Invalid module argument. The second argument must be of type [Array].');
  var isActualArguments = ofType(a, 'arguments');
  var isExpectedArray = ofType(o, Array);

  if (!isActualArguments) {
    var err = new TypeError(errActual);
    throw err;
  }

  if (!isExpectedArray) {
    var err = new TypeError(errExpected);
    throw err;
  }
}

function getActualType(actualValue) {
  if (ofType(actualValue, null)) return "null";
  if (ofType(actualValue, undefined)) return "undefined";
  if (ofType(actualValue, 'arguments')) return "arguments";
  return actualValue.constructor.name;
}

function getExpectedTypes(expectedType) {
  var types = [whenString, whenRegExp, whenObject, whenArray];

  for (var _i = 0, _types = types; _i < _types.length; _i++) {
    var type = _types[_i];
    var check = type(expectedType);
    if (check) return check;
  }

  var err = warn('typeof-arguments') + ': ' + error("The expected type is not callable.");
  throw new TypeError(err);
}

function whenString(stringType) {
  if (!ofType(stringType, String)) return null;
  var msg = "argument of type matching string expression \"".concat(stringType, "\"");
  var truthness = '';
  stringType.split('|').forEach(function (i) {
    if (i.toLowerCase() === 'truthy') truthness = '<<falsy>> ';
    if (i.toLowerCase() === 'falsy') truthness = '<<truthy>> ';
  });
  return {
    message: msg,
    truthness: truthness,
    expected: stringType
  };
}

function whenRegExp(regType) {
  if (!ofType(regType, RegExp)) return null;
  var msg = "argument of type matching regular expression ".concat(regType);
  return {
    message: msg,
    truthness: truthness(regType),
    expected: regType.toString()
  };

  function truthness(regType) {
    var isCaseInsensitive = regType.flags.match(/i/);
    var str = regType.toString();
    str = isCaseInsensitive ? str.toLowerCase() : str;
    if (str.match(/truthy/)) return '<<falsy>> ';
    if (str.match(/falsy/)) return '<<truthy>> ';
    return '';
  }

  ;
}

function whenObject(objectType) {
  if (ofType(objectType, null)) return {
    message: "argument of type [null]",
    truthness: '',
    expected: 'null'
  };
  if (ofType(objectType, undefined)) return {
    message: "argument of type [undefined]",
    truthness: '',
    expected: 'undefined'
  };
  if (ofType(objectType, Function)) return {
    message: "argument of type [".concat(objectType.name, "]"),
    truthness: '',
    expected: objectType.name
  };
  return null;
}

function whenArray(arrayTypes) {
  if (!ofType(arrayTypes, Array)) return null;
  var types = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = arrayTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var type = _step.value;
      var exp = whenObject(type);
      if (ofType(exp, null)) return null;
      types[exp.expected] = exp.expected;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var expected = Object.getOwnPropertyNames(types).join('|');
  return {
    message: "argument of type [".concat(expected, "]"),
    truthness: '',
    expected: expected
  };
}